import script from "./TicketChoiceGuide.vue?vue&type=script&lang=ts&setup=true"
export * from "./TicketChoiceGuide.vue?vue&type=script&lang=ts&setup=true"

import "./TicketChoiceGuide.vue?vue&type=style&index=0&id=de231c46&scoped=true&lang=css"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de231c46"]])

export default __exports__